/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/logo.png';

function Navbar() {
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  const handleMenuClick = () => {
    setNavbarOpen(!navbarOpen);
  };

  const mobileMenu = (
    <div className="flex flex-col items-center justify-start md:hidden">
      {/* Logo */}
      <Link
        className="flex-shrink-0 flex justify-between items-center bg-sky-400 w-full"
        to="/public"
      >
        <img
          className="2xl:h-22 xl:h-16 h-14 w-auto pl-5 pr-10 pt-1"
          src={logo}
          alt="Logo"
        />
        <FontAwesomeIcon
          onClick={handleMenuClick}
          className="md:hidden text-white text-3xl mr-4"
          icon={faClose}
        />
      </Link>
      {/* Hamburger Menu */}
      <div className="md:hidden flex-col bg-sky-400 items-center justify-end sm:justify-start space-x-4 flex w-full">
        <Link
          to="/public"
          onClick={handleMenuClick}
          className="text-white px-10 py-5 text-md border-b border-white font-medium hover:bg-gray-700"
        >
          Home
        </Link>
        <Link
          to="/public/articles"
          onClick={handleMenuClick}
          className="text-white px-10 py-5 text-md border-b border-white font-medium hover:bg-gray-700"
        >
          Articles
        </Link>
        <HashLink
          to="/public/#publications"
          onClick={handleMenuClick}
          className="text-white px-10 py-5 text-md font-medium border-b border-white hover:bg-gray-700"
        >
          Publications
        </HashLink>
        <HashLink
          to="/public/#lessons"
          className="text-white px-10 py-5 text-md border-b border-white font-medium hover:bg-gray-700"
        >
          Lessons Learnt
        </HashLink>
        <Link
          to="/public/report"
          onClick={handleMenuClick}
          className="py-5 w-full text-center animate-pulse text-md font-medium text-gray-900 hover:bg-gray-200"
        >
          Report Occurrence
        </Link>
      </div>
    </div>
  );

  const pcMenu = (
    <div className="relative flex items-center justify-between xl:h-22 h-16">
      {/* Logo */}
      <Link
        className="flex-shrink-0 flex items-center"
        to="/public"
      >
        <img
          className="2xl:h-22 xl:h-16 h-14 w-auto pl-5 pr-10 pt-1"
          src={logo}
          alt="Logo"
        />
      </Link>
      {/* Navigation Links */}
      <div className="md:flex flex-row items-center justify-end sm:justify-start space-x-4 hidden">
        <Link
          to="/public"
          className="text-white px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium hover:bg-gray-700"
        >
          Home
        </Link>
        <Link
          to="/public/articles"
          className="text-white px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium hover:bg-gray-700"
        >
          Articles
        </Link>
        <HashLink
          to="/public/#publications"
          className="text-white px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium hover:bg-gray-700"
        >
          Publications
        </HashLink>
        <HashLink
          to="/public/#lessons"
          className="text-white px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium hover:bg-gray-700"
        >
          Lessons Learnt
        </HashLink>
        <Link
          to="/public/report"
          className="px-3 py-2 rounded-md xl:text-lg lg:text-md text-sm font-medium bg-white text-gray-900 hover:bg-gray-200"
          style={{ animation: 'pulse 1.5s infinite' }}
        >
          Report Occurrence
        </Link>
      </div>
      <FontAwesomeIcon
        onClick={handleMenuClick}
        className="md:hidden text-white text-3xl mr-4"
        icon={faBars}
      />
    </div>
  );

  return (
    <nav className="xl:h-24 lg:h-18 lg:pt-2 lg:pb-2 bg-sky-400 bg-opacity-80 fixed w-full z-50 top-0">
      <div className="lg:max-w-full mx-auto sm:px-6 xl:px-24 lg:px-18 md:px-2">
        {navbarOpen ? mobileMenu : pcMenu}

      </div>
    </nav>
  );
}

export default Navbar;
